import { render, staticRenderFns } from "./IconTitle.vue?vue&type=template&id=6b859cc1&scoped=true"
import script from "./IconTitle.vue?vue&type=script&lang=js"
export * from "./IconTitle.vue?vue&type=script&lang=js"
import style0 from "./IconTitle.vue?vue&type=style&index=0&id=6b859cc1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b859cc1",
  null
  
)

export default component.exports